import React, {useEffect, useState} from "react";
import makeStyles from '@mui/styles/makeStyles';
import List from "@mui/material/List";
import HoverableListItem from "./HoverableListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import clsx from "clsx";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import {useHistory} from "react-router-dom";
import {Box} from "@mui/material";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        zIndex: 1,
        backgroundColor: theme.palette.primary.dark,
        paddingLeft: 4,
        overflowX: 'hidden',
        height: '100%',
        [theme.breakpoints.up('md')]: {
            flexShrink: 0,
            whiteSpace: 'nowrap',
        }
    },
    list: {
        backgroundColor: theme.palette.primary.dark,
        overflowX: 'hidden',
        "&::-webkit-scrollbar": {
            width: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: "10px"
        },
    },
    drawerOpen: {
        height: '100%',
        overflowX: 'hidden',
        [theme.breakpoints.up('md')]: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            width: drawerWidth
        }
    },
    drawerClose: {
        height: '100%',
        overflowX: 'hidden',
        [theme.breakpoints.up('md')]: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            width: theme.spacing(8),
        }
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    appVersion: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        textAlign: 'center',
        color: theme.palette.primary.light
    },
    // Intestazione di gruppo del menu. A drawer chiuso non c'e' spazio per il
    // testo, quindi resta solo un filetto che tiene la separazione visiva.
    groupLabel: {
        listStyle: 'none',
        margin: theme.spacing(2, 0, 0.5, 0),
        padding: theme.spacing(0, 2),
        fontSize: '0.6875rem',
        fontWeight: 700,
        letterSpacing: '0.09em',
        textTransform: 'uppercase',
        color: 'rgba(255,255,255,0.72)'
    },
    groupLabelClosed: {
        padding: theme.spacing(0, 1.5)
    },
    groupRule: {
        display: 'block',
        height: 1,
        backgroundColor: 'rgba(255,255,255,0.32)'
    }
}));

export default function Sidebar({open, setOpen, items, keepOpenOnNavigate = false}) {
    const theme = useTheme();
    const classes = useStyles();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const history = useHistory();
    const [currentPath, setCurrentPath] = useState(history.location.pathname);

    const handleDrawerClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        history.listen((location) => setCurrentPath(location.pathname));
    }, [])

    return (
        <Drawer
            variant={isDesktop ? "permanent" : "temporary"}
            anchor={"top"}
            open={open}
            onClose={handleDrawerClose}
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}
            sx={{
                "& .MuiPaper-root": {
                    backgroundColor: "unset",
                    borderBottom: 0
                }
            }}
        >
            <div className={classes.toolbar}>
                <IconButton onClick={handleDrawerClose} size="large">

                </IconButton>
            </div>
            <List className={clsx(classes.list, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}>
                {items.map(i => i.group
                    ? <li key={i.id} className={clsx(classes.groupLabel, {[classes.groupLabelClosed]: !open})}>
                        {open ? i.name : <span className={classes.groupRule}/>}
                      </li>
                    // Con keepOpenOnNavigate il drawer permanente resta aperto dopo il click.
                    // Su mobile e' un overlay e deve chiudersi comunque, altrimenti coprirebbe
                    // la pagina appena aperta.
                    : <HoverableListItem item={i} key={i.url} open={open}
                                         setOpen={isDesktop && keepOpenOnNavigate ? null : setOpen}
                                         selected={currentPath.toLowerCase().indexOf(i.url.toLowerCase().slice(0, -2)) === 0}/>
                )
                }
            </List>
            {
                open && <Box className={classes.appVersion}>{`Pin Bike frontend v${process.env.REACT_APP_VERSION}`}</Box>
            }

        </Drawer>
    );
}
